import { selectors } from 'client/reducers/blocksReducer'
import { useSelector } from 'react-redux'

export default function useBlocks(selector) {
  return useSelector(state => selector(state.blocks))
}

export { selectors }
